// extracted by mini-css-extract-plugin
module.exports = {"input":"textarea_input__3CrRv"};